import React from 'react';
import { Box, Typography, Grid2, Paper, useTheme, Icon } from '@mui/material';
import Section from './Section';

const SeccionPersonalizar = () => {
  const theme = useTheme();

  const personalizationFeatures = [
    {
      title: 'Colores de Marca',
      description: 'Elige los colores de tu marca para boletos disponibles, reservados y pagados.',
      icon: 'palette',
      color: theme.palette.primary.main,
    },
    {
      title: 'Emojis en Boletos',
      description: 'Asigna emojis divertidos para identificar boletos bloqueados, pagados o ganadores.',
      icon: 'add_reaction',
      color: theme.palette.secondary.main,
    },
    {
      title: 'Imágenes y Banners',
      description: 'Sube fotos en alta resolución de tus premios para hacer tu rifa más atractiva.',
      icon: 'image',
      color: '#10b981',
    },
    {
      title: 'Reglas y Sorteo',
      description: 'Configura la lotería, fecha de sorteo, precio y términos de entrega de premios.',
      icon: 'tune',
      color: '#6861a5',
    },
  ];

  return (
    <Section
      title="Personaliza tu Tablero"
      subtitle="Haz que tus rifas reflejen la identidad de tu negocio o causa con opciones de diseño avanzadas:"
      hasBackground={true}
      id="personalizar"
    >
      <Grid2 container spacing={3}>
        {personalizationFeatures.map((item, index) => (
          <Grid2 key={index} size={{ xs: 12, sm: 6, md: 3 }}>
            <Paper
              elevation={0}
              sx={{
                p: 3.2,
                height: '100%',
                borderRadius: '16px',
                bgcolor: theme.palette.background.paper,
                border: theme.palette.mode === 'dark' ? '1px solid rgba(255, 255, 255, 0.08)' : '1px solid #e2e8f0',
                display: 'flex',
                flexDirection: 'column',
                boxShadow: theme.palette.mode === 'dark' ? '0 4px 16px rgba(0, 0, 0, 0.3)' : '0 2px 10px rgba(0, 0, 0, 0.03)',
                transition: 'all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)',
                '&:hover': {
                  transform: 'translateY(-6px)',
                  boxShadow: theme.palette.mode === 'dark' ? '0 14px 32px rgba(0, 0, 0, 0.6)' : '0 14px 32px rgba(45, 52, 132, 0.12)',
                  borderColor: item.color,
                  '& .perso-icon-box': {
                    transform: 'scale(1.12) rotate(4deg)',
                    bgcolor: `${item.color}15`,
                    borderColor: item.color,
                  },
                },
              }}
            >
              {/* Outlined Icon Container con micro-animación */}
              <Box
                className="perso-icon-box"
                sx={{
                  width: 52,
                  height: 52,
                  borderRadius: '12px',
                  bgcolor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.04)' : '#f8fafc',
                  border: theme.palette.mode === 'dark' ? '1px solid rgba(255, 255, 255, 0.08)' : '1px solid #e2e8f0',
                  color: item.color,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mb: 2.2,
                  transition: 'all 0.3s ease',
                }}
              >
                <Icon sx={{ fontSize: 26, color: item.color }}>{item.icon}</Icon>
              </Box>
              <Typography variant="subtitle1" sx={{ fontWeight: 800, mb: 1, color: theme.palette.text.primary }}>
                {item.title}
              </Typography>
              <Typography variant="body2" sx={{ color: theme.palette.text.secondary, lineHeight: 1.6, flex: 1 }}>
                {item.description}
              </Typography>
            </Paper>
          </Grid2>
        ))}
      </Grid2>
    </Section>
  );
};

export default SeccionPersonalizar;